import { useState, useEffect, ReactNode } from 'react';
import i18n from 'typescript/application/i18n';
import PageLoader from 'typescript/components/page_loader';

interface TranslationsLoaderProps {
  children: ReactNode;
}

/**
 * i18n Translations need to be loaded before rendering the app.
 * If we don't wait for the translations to finish loading, features like using
 * the t function outside of React components will not work.
 * This component will show a loading spinner until the translations are loaded.
 */
const TranslationsLoader = ({ children }: TranslationsLoaderProps) => {
  const [areTranslationsLoaded, setAreTranslationsLoaded] = useState(false);

  useEffect(() => {
    i18n.on('initialized', () => {
      setAreTranslationsLoaded(true);
    });
  }, []);

  if (!areTranslationsLoaded) {
    return <PageLoader />;
  }

  return <>{children}</>;
};

export default TranslationsLoader;
